// extracted by mini-css-extract-plugin
export var card = "_s3-0";
export var details = "_s3-1";